import React, {createRef, useEffect, useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';
import CareerSelector from "./component/career_selector";
import useResponsive from "../hooks/responsive";


export default function ShowUniversity({universities}) {

    const [isMobile , maxWidthContainer] = useResponsive()
    const [activeUniversity, setActiveUniversity] = useState(universities[0])

    useEffect(() => {
        const listener = (event) =>{
            const slug = event.detail
            const university = universities.find(uni => uni.slug === slug)

            if(university) setActiveUniversity(university)
        }

        document.addEventListener('select_university_select', listener)

        return () => {
            document.removeEventListener('select_university_select', listener)
        }

    }, [])

    if(!activeUniversity) {
        return null
    }
    return (
        <Container isMobile={isMobile} maxWidth={maxWidthContainer}>
            <Title>Selecciona tu universidad</Title>
            <UniversityName>{activeUniversity.name}</UniversityName>
            <HelperCareer>Selecciona tu carrera</HelperCareer>

            <CareerContainer>
                {activeUniversity.careers.map(c => (<CareerSelector key={`career_selector_${c.slug}`} career={c} />))}
            </CareerContainer>


        </Container>
    )

}

const Title = styled.div`
 font-size: 36px;
 color: #FA9F63;
 padding-bottom: 8px;
`
const CareerContainer = styled.div`

`
const HelperCareer = styled.div`
    padding-top: 12px;
`
const UniversityName = styled.div`
    color: white;
    font-size: 28px;
    font-weight: bold;
`
const Container = styled.div`
    max-width: ${props => props.maxWidth}px;
    margin: auto;

    padding: ${props => props.isMobile ? '16px' : 0};
    padding-top: 52px;
`


if (document.getElementsByTagName('select-university-show')) {
    const elms = document.getElementsByTagName('select-university-show')

    for(let elm of elms) {
        const universities = JSON.parse(elm.attributes['universities'].value)
        ReactDOM.render(<ShowUniversity
            universities={universities}
        />, elm);
    }
}
